<template>
    <a-row>
        <a-col :md="12">
            <a-card title="账号信息" size="small" style="" :bordered="false">
                <a-upload
                    name="avatar" accept="image/*"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :before-upload="beforeUpload"
                    @change="handleChange"
                    action="/backend/user/avatar.php"
                >
                    <a-avatar :src="avatarURL" shape="square" :size="100" alt="avatar" />
                    <a-icon v-if="uploading" type="loading" />
                </a-upload>
                <a-descriptions>
                    <a-descriptions-item label="用户名">
                        <a :href="`/user/?id=${ userid }`" target="_blank">{{ username}}</a>
                    </a-descriptions-item>
                    <a-descriptions-item label="UID">{{ userid }}</a-descriptions-item>
                    <a-descriptions-item label="QQ">{{ qq }}</a-descriptions-item>
                </a-descriptions>
            </a-card>
            <a-card title="个性化" size="small" :bordered="false">
                <a-row>
                    <a-col v-if="bindqq">
                        签名: {{ sign }}
                        <a-button type="link" @click="setSign">
                            <a-icon type="edit"/>
                        </a-button>
                    </a-col>
                    <a-col v-else>
                        绑定qq后可设置签名
                    </a-col>
                </a-row>
            </a-card>
            <a-card title="成就" size="small" :bordered="false">
                <a-row v-for="item of achievement" :key="item.id" :gutter="16" class="achievement">
                    <a-col v-if="item.type == 'text'" :title="item.details" :offset="2">
                        <a-icon :type="getIcon(item.classification)"></a-icon>
                        <span >{{ item.name }}</span>
                    </a-col>
                    <a-col v-else-if="item.type == 'img'" :offset="2">
                        <img :src="item.details" :title="item.name" />
                    </a-col>
                </a-row>
            </a-card>
        </a-col>
        <a-col :md="12">
            <a-card title="安全" size="small" style="" :bordered="false">
                <account-item label="密码" :has="true" comment="">
                    *******
                    <template #action>
                        <a-button type="link" @click="modifyPassWord">修改</a-button>
                    </template>
                </account-item>
                <a-modal title="修改密码" width="360px"
                    :visible="changePass.dialogVisible"
                    ok-text="修改" cancel-text="取消"
                    @ok="confirmChangePass" @cancel="() => changePass.dialogVisible = false"
                    :confirm-loading="changePass.changing"
                >
                    <a-form-model :model="changePass.form" :rules="changePass.rules" ref="changePassForm" hideRequiredMark>
                        <a-form-model-item label="旧密码" prop="oldpass">
                            <a-input v-model="changePass.form.oldpass" type="password"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="新密码" prop="newpass">
                            <a-input v-model="changePass.form.newpass" type="password"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="确认密码" prop="confirm">
                            <a-input v-model="changePass.form.confirm" type="password"></a-input>
                        </a-form-model-item>
                    </a-form-model>
                </a-modal>
                <!-- <account-item label="邮箱" :has="!!email" comment="设置邮箱后，可通过邮箱找回密码">
                    {{ email }}
                </account-item> -->
                <account-item label="qq" :has="bindqq" comment="当前未绑定qq，绑定后，可通过qq找回密码">
                    {{ qq }}
                    <template #action v-if="!bindqq">
                        <a-button type="link" @click="helpBindQQ">绑定</a-button>
                        <a-button type="link" @click="modifyQQ">修改</a-button>
                    </template>
                    <template #action v-else>
                        <a-button type="link" @click="modifyBoundQQ">修改</a-button>
                    </template>
                </account-item>
                <a-modal title="修改QQ" width="360px"
                    :visible="changeQQ.dialogVisible"
                    ok-text="修改" cancel-text="取消"
                    @ok="confirmChangeQQ" @cancel="() => changePass.dialogVisible = false"
                    :confirm-loading="changeQQ.changing"
                >
                    <a-form-model :model="changeQQ.form" :rules="changeQQ.rules" ref="changeQQForm" hideRequiredMark>
                        <a-form-model-item label="密码" prop="password">
                            <a-input v-model="changeQQ.form.password" type="password" placeholder="请输入密码"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="QQ" prop="qq">
                            <a-input v-model="changeQQ.form.qq" placeholder="请输入新的qq号"></a-input>
                        </a-form-model-item>
                    </a-form-model>
                </a-modal>
            </a-card>
            <a-card title="操作" size="small" style="" :bordered="false">
                <a-button icon="poweroff" type="danger" @click="logout">退出登录</a-button>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex'
import AccountItem from '../components/AccountItem.vue'
import { hex_md5 } from '../../../utils/md5';
import { createFormData } from '../../../utils/utils';
import { prompt } from '../../../utils/mixin';

export default {
    data() {
        return {
        uploading: false,
        changePass: {
            dialogVisible: false,
            changing: false,
            form: {
                oldpass: '',
                newpass: '',
                confirm: '',
            },
            rules: {
                oldpass: [
                    { required: true, message: '请输入旧密码' }
                ],
                newpass: [
                    { validator: (rule, value, callback) => {
                        if (value.length < 8) {
                            callback(new Error("密码不得少于8位"));
                        } else if (!/\d/.test(value) || !/[a-z]/.test(value) || !/[A-Z]/.test(value)) {
                            callback(new Error("密码必须包含数字和大小写字母"));
                        } else {
                            callback();
                        }
                    }, trigger: 'change' },
                    { required: true, message: '请输入新密码' }
                ],
                confirm: [
                    { required: true, message: '请确认新密码' },
                    { validator: (rule, value, res) => {
                        if (value != this.form.newpass) {
                            res(new Error("两次输入的密码不相同"));
                        } else res();
                    }, trigger: 'blur' },
                ],
            }
        },
        changeQQ: {
            dialogVisible: false,
            changing: false,
            form: {
                password: '',
                qq: '',
            },
            rules: {
                password: [
                    { required: true, message: '请输入密码' }
                ],
                qq: [
                    { validator: (rule, value, callback) => {
                        if (!/^[1-9]\d{5,11}$/.test(value)) {
                            callback(new Error("请输入有效的qq号"));
                        } else {
                            callback();
                        }
                    }, trigger: 'change' },
                    { required: true, message: '请输入qq号' }
                ],
            }
        },
        }
    },
    computed: {
        ...mapState('$user', [
            'username', 'userid', 'email', 'qq', 'bindqq', 'achievement', 'avatarURL', 'sign'
        ]),
    },
    methods: {
        prompt,
        ...mapMutations('$user', {
            _setSign: 'setSign'
        }),
        bindEmail() {

        },
        getIcon(classification) {
            switch(classification) {
                case '身份': return 'idcard';
                case '拆塔比赛': return 'trophy';
                case '造塔比赛': return 'trophy';
                case '限时活动': return 'team';
                case '造塔活动': return 'team';
                case '比赛主办': return 'schedule';
                case '比赛协力': return 'schedule';
            }
        },
        async logout() {
            await axios.get("/backend/user/logout.php");
            window.location.assign("/user/login.html");
        },
        modifyPassWord() {
            this.changePass.dialogVisible = true;
        },
        helpBindQQ() {
            this.$info({
                title: '如何绑定qq',
                content: h => (
                    <div>
                        <p>
                            用账号对应的qq加入
                            <a href="https://jq.qq.com/?_wv=1027&k=nJMrECRy" target="_blank">h5魔塔交流群</a>
                            私聊机器人[<b>h5魔塔助手改</b>], 输入【绑定】即可进入绑定流程<br/>
                        </p>
                        <p>
                            <a href="https://h5mota.com/bbs/thread/?tid=355&p=1">详细帮助</a>
                        </p>
                    </div>
                )
            });
        },
        modifyBoundQQ() {
            this.$info({
                title: '更换绑定qq',
                content: (h) => (
                    <div>
                        <p>
                            目前暂不支持自行更换已经绑定的qq，如有需要请加入
                            <a href="https://jq.qq.com/?_wv=1027&k=nJMrECRy" target="_blank">h5魔塔交流群</a>
                            联系群主进行更换
                        </p>
                    </div>
                )
            });
        },
        async confirmChangePass() {
            this.$refs.changePassForm.validate();
            return new Promise((res, rej) => {
                this.$refs.changePassForm.validate(async (valid) => {
                    if (!valid) return;
                    const { oldpass, newpass } = this.changePass.form;
                    const { data } = await axios
                        .post("/backend/user/password.php", createFormData({
                            type: "update", oldPass: hex_md5(oldpass), newPass: hex_md5(newpass)
                        }));
                    if (data.code == -1) {
                        this.$message.error("密码错误");
                    } else {
                        this.changePass.dialogVisible = false;
                    }
                    res();
                })
            });
        },
        async confirmChangeQQ() {
            this.$refs.changeQQForm.validate();
            return new Promise((res, rej) => {
                this.$refs.changeQQForm.validate(async (valid) => {
                    if (!valid) return;
                    const { password, qq } = this.changeQQ.form;
                    console.log(password, qq);
                    const { data } = await axios
                        .post("/backend/user/changeQQ.php", createFormData({
                            password: hex_md5(password), qq
                        }));
                    if (data.code === -1) {
                        this.$message.error("密码错误");
                    } else if (data.code === -2) {
                        this.$message.error("qq号已经被使用，如果此qq号属于您，请与网站管理联系");
                    } else {
                        this.changeQQ.dialogVisible = false;
                        location.reload();
                    }
                    res();
                })
            });
        },
        modifyQQ() {
            this.changeQQ.dialogVisible = true;
        },
        beforeUpload(file) {
            if (file.size > 1024 * 1024) {
                this.$message.error('头像最大不能超过1MB');
                return false;
            }
            return true;
        },
        handleChange(res) {
            const file = res.file;
            if (file.status == "uploading") {
                this.uploading = true;
            } else {
                this.uploading = false;
                if (file.response.code == 0) {
                    this.$message.success('文件上传成功');
                    window.location.reload();
                } else if (file.response.code == -1) {
                    this.$message.error('文件上传失败');
                } else if (file.response.code == -2) {
                    this.$message.error('文件大小超限');
                } else if (file.response.code == -3) {
                    this.$message.error('不支持的文件格式');
                }
            }
        },
        async setSign() {
            const newSign = await this.prompt("设置签名", 30);
            if (newSign === null) {
                return;
            }
            const { data } = await axios
                .post("/backend/user/setSign.php", createFormData({
                    sign: newSign
                }));
            if (data.code === 0) {
                this.$message.success("修改成功");
                this._setSign(newSign);
            }
        }
    },
    components: {
        AccountItem
    }
}
</script>

<style scoped>
.ant-card {
    background: none;
}
.ant-card >>> .ant-card-head-title {
    font-size: 18px;
    font-weight: bold;
}
.ant-descriptions {
    font-size: 16px;
}
</style>